"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/query/' + id,
      method: 'post'
    });
  },
  getPageDetail: function getPageDetail(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/page/query/' + id,
      method: 'post'
    });
  },
  getAuthDetail: function getAuthDetail(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/queryPrivilege/' + id,
      method: 'post'
    });
  },
  auth: function auth(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/privilege',
      method: 'post',
      data: data
    });
  },
  publish: function publish(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/publish/' + id,
      method: 'post'
    });
  },
  unpublish: function unpublish(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/cancel_publish/' + id,
      method: 'post'
    });
  },
  disable: function disable(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/disabled/' + id,
      method: 'post'
    });
  },
  saveItem: function saveItem(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/save',
      method: 'post',
      data: data
    });
  },
  deleteItem: function deleteItem(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/delete/' + id,
      method: 'post'
    });
  },
  saveArticle: function saveArticle(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/page/save',
      method: 'post',
      data: data
    });
  },
  deleteArticle: function deleteArticle(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/message/page/delete/' + id,
      method: 'post'
    });
  }
};